export enum TYPE {
  DAILY = "daily",
  DATERANGE = "daterange",
  EMAIL = "EMAIL",
}
export enum STATUS {
  APPROVED = "APPROVED",
  AVAILABLE = "AVAILABLE",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  OnHOLD = "ON HOLD",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}
